import React from 'react';
import styled from 'styled-components';
import ConfidenceBadge from '../ConfidenceBadge';

const StyledWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const SuggestionLabel = ({ label, suggestion }) => (
  <StyledWrapper>
    {label}
    {suggestion && <ConfidenceBadge suggestion={suggestion} />}
  </StyledWrapper>
);

export default SuggestionLabel;
